import { render, staticRenderFns } from "./rkm.vue?vue&type=template&id=2b1838c1&scoped=true&"
import script from "./rkm.vue?vue&type=script&lang=js&"
export * from "./rkm.vue?vue&type=script&lang=js&"
import style0 from "./rkm.vue?vue&type=style&index=0&id=2b1838c1&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b1838c1",
  null
  
)

export default component.exports